// Sample vehicle and driver images for demonstration
// These are fallback placeholders - real images come from database

export const sampleVehicleImages = {
  // Using reliable placeholder service
  sedan: 'https://via.placeholder.com/300x200/E5E7EB/6B7280?text=Sedan',
  suv: 'https://via.placeholder.com/300x200/E5E7EB/6B7280?text=SUV',
  hatchback: 'https://via.placeholder.com/300x200/E5E7EB/6B7280?text=Hatchback',
  truck: 'https://via.placeholder.com/300x200/E5E7EB/6B7280?text=Truck',
  van: 'https://via.placeholder.com/300x200/E5E7EB/6B7280?text=Van',
  default: 'https://via.placeholder.com/300x200/E5E7EB/6B7280?text=Vehicle'
};

export const sampleDriverImages = {
  // Using reliable placeholder service
  male1: 'https://via.placeholder.com/150/E5E7EB/6B7280?text=Driver',
  male2: 'https://via.placeholder.com/150/E5E7EB/6B7280?text=Driver',
  male3: 'https://via.placeholder.com/150/E5E7EB/6B7280?text=Driver',
  female1: 'https://via.placeholder.com/150/E5E7EB/6B7280?text=Driver',
  female2: 'https://via.placeholder.com/150/E5E7EB/6B7280?text=Driver',
  default: 'https://via.placeholder.com/150/E5E7EB/6B7280?text=Driver'
};

// Function to get a random vehicle image (fallback only)
export const getRandomVehicleImage = () => {
  const images = Object.values(sampleVehicleImages);
  return images[Math.floor(Math.random() * images.length)];
};

// Function to get a random driver image (fallback only)
export const getRandomDriverImage = () => {
  const images = Object.values(sampleDriverImages);
  return images[Math.floor(Math.random() * images.length)];
};

// Function to get vehicle image based on make/model (fallback only)
export const getVehicleImageByType = (makeModel: string) => {
  const model = makeModel.toLowerCase();
  
  if (model.includes('suv') || model.includes('prado') || model.includes('patrol')) {
    return sampleVehicleImages.suv;
  } else if (model.includes('truck') || model.includes('pickup')) {
    return sampleVehicleImages.truck;
  } else if (model.includes('van') || model.includes('hiace')) {
    return sampleVehicleImages.van;
  } else if (model.includes('hatchback') || model.includes('yaris')) {
    return sampleVehicleImages.hatchback;
  } else {
    return sampleVehicleImages.sedan;
  }
};
